// NYClock.jsx
import React, { useEffect, useState } from "react";

const NY_TZ = "America/New_York";

function formatWithOrdinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export default function NYClock() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const weekday = new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    timeZone: NY_TZ,
  }).format(now);

  const monthShort = new Intl.DateTimeFormat("en-US", {
    month: "short",
    timeZone: NY_TZ,
  }).format(now);

  const monthLong = new Intl.DateTimeFormat("en-US", {
    month: "long",
    timeZone: NY_TZ,
  }).format(now);

  const day = parseInt(
    new Intl.DateTimeFormat("en-US", { day: "numeric", timeZone: NY_TZ }).format(
      now
    ),
    10
  );

  const year = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    timeZone: NY_TZ,
  }).format(now);

  const time = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    timeZone: NY_TZ,
  }).format(now);

  return (
    <>
      <div className="lh-title">{monthLong}</div>
      <div className="lh-subtitle">
        Today is {weekday}, {monthShort} {formatWithOrdinal(day)}, {year} – {time}
      </div>
    </>
  );
}
